import type { PropType } from 'vue';

export type ComponentSizes = 'small' | 'medium' | 'large';

export const componentSizeMap: Record<ComponentSizes, number> = {
    large: 36,
    medium: 28,
    small: 24,
} as const;

export const componentDefaultSize: ComponentSizes = 'large';

export const componentSizeProp = {
    type: String as PropType<ComponentSizes>,
    default: componentDefaultSize,
    required: false,
};
